import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import DropdownListBox from '../Form/common/DropdownListBox';
import { FormLabel } from '../Form/form.styles';
import { DropdownListBoxProps } from '../Form/common/DropdownListBox/DropdownListBox';

export const ChipPanelWrapper = styled.div<{
  hasLabel: boolean;
}>`
  position: relative;

  ${FormLabel} {
    margin-bottom: 8px;
    display: inline-block;
  }
`;

const ChipPanel = styled(DropdownListBox, {
  shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'alignRight',
})<DropdownListBoxProps & { alignRight?: boolean }>(({ alignRight }) => ({
  minWidth: '280px',
  width: 'unset',
  ...(alignRight
    ? {
        left: 'unset !important',
        right: 0,
      }
    : {}),
}));

export default {
  ChipPanelWrapper,
  ChipPanel,
};
